import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useState, useEffect } from 'react';
import { AnalyticsListener as AKAnalyticsListener } from '@atlaskit/analytics-next';
import { getAnalyticsWebClient } from './analyticsWebClient';
export var ANALYTICS_CHANNEL = 'embeddedConfluence';
var packageName = "@atlassian/embedded-confluence";
var packageVersion = "15.2.7";
var AnalyticsListener = function AnalyticsListener(_ref) {
  var children = _ref.children,
    embeddedConfluenceSource = _ref.embeddedConfluenceSource,
    hostname = _ref.hostname,
    parentProduct = _ref.parentProduct,
    userInfo = _ref.userInfo;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    analyticsClient = _useState2[0],
    setAnalyticsClient = _useState2[1];
  useEffect(function () {
    getAnalyticsWebClient({
      hostname: hostname,
      userInfo: userInfo
    }).then(function (res) {
      setAnalyticsClient(res);
    });
  }, [hostname, userInfo]);
  var onEvent = useCallback(function (_ref2) {
    var _analyticsClient$onEv;
    var payload = _ref2.payload;
    analyticsClient === null || analyticsClient === void 0 || (_analyticsClient$onEv = analyticsClient.onEvent) === null || _analyticsClient$onEv === void 0 || _analyticsClient$onEv.call(analyticsClient, ANALYTICS_CHANNEL, _objectSpread(_objectSpread({}, payload), {}, {
      attributes: _objectSpread(_objectSpread({}, payload === null || payload === void 0 ? void 0 : payload.attributes), {}, {
        embeddedConfluenceSource: embeddedConfluenceSource,
        packageName: packageName,
        packageVersion: packageVersion,
        parentProduct: parentProduct
      })
    }));
  }, [analyticsClient, parentProduct, embeddedConfluenceSource]);
  if (!analyticsClient) {
    return null;
  }
  return /*#__PURE__*/React.createElement(AKAnalyticsListener, {
    channel: ANALYTICS_CHANNEL,
    onEvent: onEvent
  }, children);
};
export default AnalyticsListener;